import { ModalProps } from 'antd';
import CloseButton from 'components/new-ui/composed/modal/filters-modal/CloseButton';
import Button from 'components/new-ui/base/button/Button';
import { ReactElement } from 'react';
import { StyledModal, StyledModalBody, StyledModalFooter, StyledModalHeaderWrapper } from './styles';
import { H5 } from 'components/ui/base/typography';

interface Props extends ModalProps {
    clearButtonText?: string;
    submitButtonText?: string;
    clearButtonDisabled?: boolean;
    submitButtonDisabled?: boolean;
    header?: ReactElement;
    onClose: () => void;
    onClearFilters: () => void;
    onSubmit: () => void;
}

const FiltersModal = ({
    header,
    title = 'Default Modal Title',
    clearButtonText = 'Clear All Filters',
    submitButtonText = 'See Results',
    submitButtonDisabled = false,
    clearButtonDisabled = false,
    width = 840,
    onClose,
    onClearFilters,
    onSubmit,
    children,
    ...rest
}: Props) => {
    return (
        <StyledModal destroyOnClose width={width} footer={null} title={null} closable hideCloseButton {...rest}>
            {header ? (
                <StyledModalHeaderWrapper>{header}</StyledModalHeaderWrapper>
            ) : (
                <StyledModalHeaderWrapper>
                    <H5>{title}</H5>
                    <CloseButton onClose={onClose} />
                </StyledModalHeaderWrapper>
            )}
            <StyledModalBody>{children}</StyledModalBody>

            <StyledModalFooter>
                <Button onClick={onClearFilters} disabled={clearButtonDisabled}>
                    {clearButtonText}
                </Button>
                <Button type="primary" onClick={onSubmit} disabled={submitButtonDisabled}>
                    {submitButtonText}
                </Button>
            </StyledModalFooter>
        </StyledModal>
    );
};

export default FiltersModal;
